import { useEffect, useMemo, useState } from "react";
import { Plus } from "lucide-react";
import api from "../../lib/api";
import SearchSelect from "../SearchSelect";
import { Button } from "../ui/button";
import CompanyFormDialog from "./CompanyFormDialog";

export default function CompanySearchSelect({ value, onChange, canCreate = false, onCreated, disabled = false, "data-testid": testid = "company-search-select" }) {
    const [query, setQuery] = useState("");
    const [companies, setCompanies] = useState([]);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [createOpen, setCreateOpen] = useState(false);

    useEffect(() => {
        if (!value || selected?.company_id === value) return;
        api.get("/companies").then(({ data }) => setSelected((data || []).find((item) => item.company_id === value) || null)).catch(()=>{});
    }, [value, selected?.company_id]);

    useEffect(() => {
        const term = query.trim();
        if (!term) { setCompanies([]); setLoading(false); return; }
        setLoading(true);
        const timer = setTimeout(() => {
            api.get("/companies", { params: { q: term } })
                .then(({ data }) => setCompanies(data || []))
                .catch(() => setCompanies([]))
                .finally(() => setLoading(false));
        }, 250);
        return () => clearTimeout(timer);
    }, [query]);

    const options = useMemo(() => {
        const map = new Map();
        if (selected) map.set(selected.company_id, selected);
        companies.forEach((company) => map.set(company.company_id, company));
        return [...map.values()].map((company) => ({
            value: company.company_id,
            label: company.name,
            keywords: `${company.industry || ""} ${company.city || ""}`,
        }));
    }, [companies, selected]);

    const handleChange = (companyId) => {
        const company = companies.find((item) => item.company_id === companyId) || (selected?.company_id === companyId ? selected : null);
        if (company) setSelected(company);
        onChange(companyId, company);
    };

    return (
        <>
            <SearchSelect value={value || ""} onChange={handleChange} options={options} searchValue={query} onSearchChange={setQuery} showOptionsWhenEmpty={false} loading={loading} disabled={disabled} placeholder="Selecciona una empresa" searchPlaceholder="Buscar empresa..." emptyText="Sin empresas encontradas" data-testid={testid} footer={canCreate ? <Button type="button" variant="ghost" className="w-full justify-start text-orange-600" onClick={() => setCreateOpen(true)}><Plus className="mr-2 h-4 w-4"/>Agregar nueva empresa</Button> : null} />
            {canCreate && <CompanyFormDialog open={createOpen} onOpenChange={setCreateOpen} onSaved={(company) => { setSelected(company); onChange(company.company_id, company); onCreated?.(company); }} />}
        </>
    );
}
